<template>
  <div class="pneu-lancamento ml-4 mr-4">
    <div class="row">
      <div class="col-6">
        <div class="col-12">
          <div>
            <b-row>
              <b-col cols="7">
                <label for="input-filial">Empresa</label>
                <div>
                  <b-form-select
                    id="fun-empresa"
                    v-model="value_empresa"
                    required
                    :options="empresas"
                    class="mb-3"
                    text-field="empresa"
                    @change="loadFilial()"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="5">
                <label for="input-filial">Filial</label>
                <div>
                  <b-form-select
                    id="fun-filial"
                    v-model="value_filial"
                    required
                    :options="filiais"
                    class="mb-3"
                    text-field="filial"
                    @change="loadAcao(tabTitle), loadDanos()"
                  >
                  </b-form-select>
                </div>
              </b-col>
            </b-row>

            <!--acao -->
            <b-row>
              <b-col cols="12">
                <label for="input-pnefabricante">Rotina</label> --
                {{ value_acao }}
                <div>
                  <b-form-select
                    v-model="value_acao"
                    required
                    :options="acoes"
                    class="mb-3"
                    text-field="acao"
                  >
                  </b-form-select>
                </div>
              </b-col>
            </b-row>

            <!-- RECAPADORA -->
            <!-- RECAPADORA -->
            <!-- RECAPADORA -->
            <!-- RECAPADORA -->
            <!-- RECAPADORA -->

            <b-row>
              <b-col cols="1" v-show="value_acao === 4">
                <label for="input-live"></label>
                <b-button
                  class="mr-2 mt-2 mb-0"
                  variant="success"
                  @click="loadNovoNroRomaneio(), loadPneuFornecedores()"
                  >Romaneio</b-button
                >
              </b-col>

              <b-col cols="2" class="ml-2" v-show="value_acao === 4">
                <label for="input-live">Nº Romaneio</label>
                <b-input-group-text
                  >{{ nroromaneio.length !== 0 ? nroromaneio : "-" }}
                </b-input-group-text>
              </b-col>

              <b-col
                cols="6"
                v-show="
                  value_acao === 4 || value_acao === 5 || value_acao === 10
                "
              >
                <label for="input-pnefabricante">FORNECEDOR / CLIENTE</label>
                <div>
                  <b-form-select
                    v-model="value_fornecedor"
                    required
                    :options="fornecedores"
                    class="mb-3"
                    text-field="nome"
                    @click="
                      loadPneuFornecedores(),
                        loadPneuRecapadoraServico(),
                        loadPneuRecapagemTipo()
                    "
                    @change="
                      loadAvarias(),
                        loadPneuRecapadoraServico(),
                        loadPneuRecapagemTipo(),
                        loadBorracha(),
                        loadCarcaca()
                    "
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6" v-show="value_acao == 9">
                <label for="input-pnefabricante">FORNECEDOR / CLIENTE</label>
                <div>
                  <b-form-select
                    v-model="value_fornecedor"
                    required
                    :options="fornecedores"
                    class="mb-3"
                    text-field="nome"
                    @click="
                      loadPneuFornecedores(),
                        loadPneuRecapadoraServico(),
                        loadPneuRecapagemTipo()
                    "
                    @change="
                      loadAvarias(),
                        loadPneuRecapadoraServico(),
                        loadPneuRecapagemTipo(),
                        loadBorracha(),
                        loadCarcaca()
                    "
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2" v-show="value_acao === 5">
                <label for="input-registro">Nº NOTA FISCAL</label>
                <b-form-input
                  v-model="value_pneu_nfs"
                  required
                  placeholder="Nº da NFS"
                  v-b-tooltip.hover
                  title="Digite o nº da nota fiscal"
                ></b-form-input>
              </b-col>

              <b-col cols="2" v-show="value_acao === 5">
                <label for="datepicker-placeholder">DATA EMISSÃO</label>
                <b-form-datepicker
                  id="dt_sol_inicial"
                  required
                  v-model="value_dt_emissao"
                  placeholder="Emissão "
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </b-col>

              <b-col cols="2" v-show="value_acao === 5">
                <label for="input-pnefabricante">SERVIÇO</label> --
                {{ value_servico }}
                <div>
                  <b-form-select
                    v-model="value_servico"
                    required
                    :options="recapadoraservico"
                    class="mb-3"
                    text-field="servico"
                  >
                  </b-form-select>
                </div>
              </b-col>
            </b-row>

            <!-- DANOS / AVARIAS -->
            <b-row v-show="value_acao !== 5">
              <b-col cols="6">
                <label for="input-pnefabricante">DANOS</label>
                <div>
                  <b-form-select
                    v-model="value_danos_id"
                    required
                    :options="danos"
                    class="mb-3"
                    text-field="danos"
                    TIPO
                    RECAPAGEM
                    @change="loadAvarias()"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6">
                <label for="input-pnefabricante">AVARIA</label>
                <div>
                  <b-form-select
                    v-model="value_avaria_id"
                    required
                    :options="avarias"
                    class="mb-3"
                    text-field="avaria"
                  >
                  </b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-col cols="12">
              <b-form-textarea
                id="infoConteudo"
                v-model="value_observacao"
                size="sm"
                rows="2"
                placeholder="Observações do pneu"
              ></b-form-textarea>
            </b-col>

            <!--     seleção por pneu -->
            <!--     seleção por pneu -->
            <!--     seleção por pneu -->

            <b-row
              v-show="
                value_acao === 4 ||
                value_acao === 5 ||
                value_acao === 6 ||
                value_acao === 7 ||
                value_acao === 9 ||
                value_acao === 12
              "
            >
              <b-col cols="2">
                <label for="input-registro">Nº DE FOGO</label>
                <b-form-input
                  @keyup.enter="loadPneu()"
                  v-model="value_pneu_colocado"
                  placeholder="Nº do pneu"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col v-if="value_acao === 5" cols="2">
                <label for="input-registro">R$ VALOR</label>
                <b-form-input
                  v-model="value_vlr_pneu_conserto"
                  placeholder="valor do serviço"
                  v-b-tooltip.hover
                  title="Digite o valor do serviço realizado no pneu"
                ></b-form-input>
              </b-col>

              <b-col cols="3">
                <label for="input-live">VIDA</label>
                <b-input-group-text
                  >{{ pneuselecao.length !== 0 ? pneuselecao["vida"] : "-" }}
                </b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">FABRICANTE</label>
                <b-input-group-text
                  >{{
                    pneuselecao.length !== 0 ? pneuselecao["fabricante"] : "-"
                  }}
                </b-input-group-text>
              </b-col>

              <b-col cols="2">
                <label for="input-live">MEDIDA</label>
                <b-input-group-text
                  >{{ pneuselecao.length !== 0 ? pneuselecao["medida"] : "-" }}
                </b-input-group-text>
              </b-col>
            </b-row>

            <!-- 5-retorno recapadora -->
            <!-- 5-retorno recapadora -->
            <!-- 5-retorno recapadora -->

            <b-row v-show="value_acao === 5">
              <b-col cols="2" v-show="value_servico === 2">
                <label for="input-pnefabricante">TIPO RECAPAGEM</label>
                <div>
                  <b-form-select
                    v-model="value_recapagemtipo"
                    required
                    :options="recapagemtipo"
                    class="mb-3"
                    text-field="tipo"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="3" v-show="value_servico === 2">
                <label for="input-pnefabricante">CARCAÇA</label>
                <div>
                  <b-form-select
                    v-model="value_carcaca"
                    required
                    :options="carcacas"
                    class="mb-3"
                    text-field="desenho"
                    @change="loadAvarias()"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="3" v-show="value_servico === 2">
                <label for="input-pnefabricante">BORRACHA</label>
                <div>
                  <b-form-select
                    v-model="value_borracha"
                    required
                    :options="borrachas"
                    class="mb-3"
                    text-field="borracha"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2" v-show="value_servico === 2">
                <b-form-checkbox
                  class="mb-3 mt-5"
                  v-model="value_sucata"
                  name="checkbox-2"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Rejeitado -- {{ value_sucata }}
                </b-form-checkbox>
              </b-col>

              <!--
        <b-col cols="12">
      <b-form-textarea                   
        id="infoConteudo"
        v-model="value_observacao"
        size="sm"
        rows="2"            
        placeholder="Observações do pneu"                      
      ></b-form-textarea>
    </b-col>   
    -->
            </b-row>

            <!-- 12-Checklist - bancada -->
            <!-- 12-Checklist - bancada -->
            <!-- 12-Checklist - bancada -->

            <b-row
              v-show="value_acao === 12 || value_acao === 11"
              class="blue-border rounded mb-3 mt-3 ml-2 mr-2"
            >
              <b-col cols="2">
                <b-form-checkbox
                  id="APP-Alinhamento"
                  class="mb-2 mt-2"
                  v-model="pneu.alinhamento"
                  name="checkbox-Alinhamento"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Alinhamento
                </b-form-checkbox>
              </b-col>

              <b-col cols="2">
                <b-form-checkbox
                  id="APP-Balanceamento"
                  class="mb-2 mt-2"
                  v-model="pneu.balanceamento"
                  name="checkbox-Balanceamento"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Balanceamento
                </b-form-checkbox>
              </b-col>

              <b-col cols="2">
                <b-form-checkbox
                  id="APP-Calibragem"
                  class="mb-2 mt-2"
                  v-model="pneu.calibragem"
                  name="checkbox-Calibragem"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Calibragem
                </b-form-checkbox>
              </b-col>

              <b-col cols="2">
                <b-form-checkbox
                  id="APP-TampaMetalica"
                  class="mb-2 mt-2"
                  v-model="pneu.tampa_metalica"
                  name="checkbox-TampaMetalica"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Tampa metálica
                </b-form-checkbox>
              </b-col>

              <b-col cols="2">
                <b-form-checkbox
                  id="APP-Nitrogenio"
                  class="mb-2 mt-2"
                  v-model="pneu.nitrogenio"
                  name="checkbox-Nitrogenio"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Nitrogênio
                </b-form-checkbox>
              </b-col>

              <b-col cols="2">
                <b-form-checkbox
                  id="APP-Ressulcado"
                  class="mb-2 mt-2"
                  v-model="pneu.ressulcado"
                  name="checkbox-Ressulcado"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Ressulcado
                </b-form-checkbox>
              </b-col>
            </b-row>

            <!--     seleção por carro -->
            <!--     seleção por carro -->
            <!--     seleção por carro -->
            <!--     seleção por carro -->
            <!--     seleção por carro -->

            <b-row
              v-show="
                value_acao === 1 ||
                value_acao === 2 ||
                value_acao === 3 ||
                value_acao === 11 ||
                value_acao === 8 ||
                value_acao === 10
              "
            >
              <b-col cols="4" class="mb-2 mt-6">
                <label for="input-registro">Nº DO CARRO</label>
                <b-form-input
                  @keyup.enter="
                    loadVeiculo(),
                      loadPneuVeiculo(),
                      loadPneuAlocadoA(),
                      loadPneuAlocadoB()
                  "
                  v-model="pneu.prefixo"
                  required
                  placeholder="Nº do carro"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col cols="4">
                <label for="input-live">PLACA</label>
                <b-input-group-text>
                  {{
                    veiculos.length > 0
                      ? veiculos.map((at) => at.placa).join(", ")
                      : "-"
                  }}</b-input-group-text
                >
              </b-col>

              <b-col cols="4">
                <label for="input-live">MODELO CHASSI</label>
                <b-input-group-text>
                  {{
                    veiculos.length > 0
                      ? veiculos.map((at) => at.chassimodelo).join(", ")
                      : "-"
                  }}</b-input-group-text
                >
              </b-col>
              <!-- lançamentos tipo de ação            -->
              <!-- lançamentos tipo de ação            -->
              <!-- lançamentos tipo de ação            -->
              <!-- lançamentos tipo de ação            -->
              <!-- lançamentos tipo de ação            -->
              <!-- lançamentos tipo de ação            -->
              <b-col cols="12">
                <b-table
                  id="pneucarro"
                  small
                  hover
                  striped
                  sticky-header="335px"
                  :items="pneunoveiculo"
                  :fields="fieldspneucarro"
                >
                  <template slot="cell(actions)" slot-scope="data">
                    <b-button
                      @click="editPneu(data.item)"
                      title="Editar Pneu"
                      size="sm"
                      variant="warning"
                      class="mr-2 mt-2"
                    >
                      <i class="fa fa-exclamation-circle"></i>
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row
              v-show="
                value_acao == 3 ||
                value_acao == 11 ||
                value_acao == 1 ||
                value_acao == 2 ||
                value_acao == 10
              "
            >
              <b-col cols="2">
                <label for="input-live">PNEU SELECIONADO</label>
                <b-input-group-text>{{
                  typeof pneu !== "undefined" &&
                  pneu.nrofogo !== undefined &&
                  pneu.nrofogo > 0
                    ? pneu.nrofogo
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">SULCO</label>
                <b-input-group-text>{{
                  typeof pneu !== "undefined" && pneu.sulco !== undefined
                    ? pneu.sulco
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">LIBRAS</label>
                <b-input-group-text>{{
                  typeof pneu !== "undefined" && pneu.libras !== undefined
                    ? pneu.libras
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="2">
                <label for="input-live">VIDA</label>
                <b-input-group-text>{{
                  typeof pneu !== "undefined" && pneu.vida !== undefined
                    ? pneu.vida
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">EIXO</label>
                <b-input-group-text>{{
                  typeof pneu !== "undefined" && pneu.eixo !== undefined
                    ? pneu.eixo
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">POSIÇÃO</label>
                <b-input-group-text>{{
                  pneu.posicao ? pneu.posicao : "-"
                }}</b-input-group-text>
              </b-col>
            </b-row>

            <!--- PNEU RODIZIO  -->
            <b-row v-show="value_acao === 8">
              <b-col cols="4">
                <label for="input-pnefabricante">POSIÇÃO A</label>
                {{
                  rodozioA.find((item) => item.posicao_id === pneuA_id)
                    ?.nrofogo_id
                }}
                <div>
                  <b-form-select
                    v-model="pneuA_id"
                    required
                    :options="rodozioA"
                    class="mb-3"
                    text-field="posicao"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="4">
                <label for="input-pnefabricante">POSIÇÃO B</label>
                {{
                  rodozioB.find((item) => item.posicao_id === pneuB_id)
                    ?.nrofogo_id
                }}
                <div>
                  <b-form-select
                    v-model="pneuB_id"
                    required
                    :options="rodozioB"
                    class="mb-3"
                    text-field="posicao"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="4" class="mb-2 mt-3" v-show="value_acao === 8">
                <b-button
                  class="mt-3 mb-4"
                  variant="success"
                  block
                  @click="
                    uptPneusVeiculoRodizio(
                      pneuA_id,
                      rodozioB.find((item) => item.posicao_id === pneuB_id)
                        ?.nrofogo_id
                    ),
                      uptPneusVeiculoRodizio(
                        pneuB_id,
                        rodozioA.find((item) => item.posicao_id === pneuA_id)
                          ?.nrofogo_id
                      ),
                      postPneusMovRodizio(
                        pneuA_id,
                        rodozioB.find((item) => item.posicao_id === pneuB_id)
                          ?.nrofogo_id
                      ),
                      postPneusMovRodizio(
                        pneuB_id,
                        rodozioA.find((item) => item.posicao_id === pneuA_id)
                          ?.nrofogo_id
                      )
                  "
                  >Rodízio</b-button
                >
              </b-col>
            </b-row>

            <b-row v-show="value_acao === 1 || value_acao === 3">
              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">PNEU COLOCADO</label>
                <b-form-input
                  v-model="value_pneu_colocado"
                  @keyup.enter="loadPneu()"
                  required
                  placeholder="informe o Nº do pneu"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">SULCO</label>
                <b-form-input
                  v-model="pneu.sulco"
                  required
                  placeholder="sulco em MM"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">LIBRAS</label>
                <b-form-input
                  v-model="pneu.libras"
                  required
                  placeholder="qtd de libras"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col cols="2">
                <label for="input-live">VIDA</label>
                <b-input-group-text
                  >{{ pneuselecao.length !== 0 ? pneuselecao["vida"] : "-" }}
                </b-input-group-text>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">HODÔMETRO</label>
                <b-form-input
                  v-model="pneu.odometro"
                  required
                  placeholder="odometro do carro"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-col cols="12" class="mb-2 mt-3" v-show="value_acao !== 8">
              <b-button
                class="mt-3 mb-4"
                variant="success"
                block
                @click="postPneusMov()"
                >Gravar</b-button
              >
            </b-col>
          </div>
        </div>
      </div>

      <div class="col-6">
        <!--  TABLE DE DADOS  DO PNEU SELECIONADO                           -->

        <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
          <b-card
            class="ml-2"
            style="width: 33rem"
            border-variant="success"
            header="QUANTIDADE DE LANÇAMENTOS REALIZADOS"
            header-bg-variant="success"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ pneunoregistros ? pneunoregistros.length : 0 }}
              </h2>
            </b-card-text>
          </b-card>
        </b-card-group>

        <div class="col-12">
          <!--tbl de dados -->
          <b-table
            id="tbldefeitos"
            small
            hover
            striped
            sticky-header="660px"
            :items="pneunoregistros"
            :fields="situacaopneu"
          >
            <template slot="cell(actions)" slot-scope="data">
              <b-button
                @click="editPneu(data.item)"
                size="sm"
                variant="success"
                class="mr-2"
              >
                <i class="fa fa-exclamation-circle"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "PneuLancamento",

  /*
    computed: mapState(['user']),   
    */

  computed: {
    ...mapState(["user"]),

    //////////////////
  },

  props: {
    tabTitle: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      //////////////
      //opcao: false,
      pneus: [],
      pneu: {},
      filiais: [],
      fabricantes: [],
      modelos: [],
      vidas: [],
      borrachas: [],
      carcacas: [],
      statuss: [],
      acoes: [],
      veiculos: [],
      pneunoveiculo: [],
      pneulancamentos: [],
      danos: [],
      avarias: [],
      value_acao: 0,
      value_empresa: 0,
      value_filial: 0,
      pneu_nrofogo: "",
      pneuselecao: [],
      value_pneu_colocado: "",
      value_pneu_nfs: "",
      value_vlr_pneu_conserto: 0.0,
      value_danos_id: 0,
      value_avaria_id: 0,
      value_observacao: "",
      pneunoregistros: [],
      rodozioA: [],
      rodozioB: [],
      pneuA_id: 0,
      pneuB_id: 0,
      nroromaneio: [],
      fornecedores: [],
      value_fornecedor: 0,
      value_dt_emissao: "",
      value_borracha: null,
      value_carcaca: null,
      recapadoraservico: [],
      recapagemtipo: [],
      value_servico: 0,
      value_recapagemtipo: 0,
      value_sucata: false,

      fieldspneucarro: [
        { key: "eixo", label: "Eixo", sortable: true },
        { key: "lado", label: "Lado", sortable: true },
        { key: "posicao", label: "Posição", sortable: true },
        { key: "nrofogo", label: "Nº de fogo", sortable: true },
        { key: "fabricante", label: "Fabricante", sortable: true },
        { key: "carcaca", label: "Carcaça", sortable: true },
        { key: "medida", label: "Medida", sortable: true },
        { key: "vida", label: "Vida", sortable: true },
        { key: "km_rodado", label: "Km_rodado", sortable: true },
        { key: "sulco", label: "sulco", sortable: true },
        { key: "libras", label: "libras", sortable: true },
        { key: "actions", label: "Ações" },
      ],

      situacaopneu: [
        { key: "id", label: "Lançamento", sortable: true },
        { key: "acao", label: "Rotina", sortable: true },
        { key: "nrofogo", label: "Nº de fogo", sortable: true },
        { key: "prefixo", label: "Nº do carro", sortable: true },
        { key: "posicao", label: "Posição", sortable: true },
        { key: "fabricante_pneu", label: "Fabricante", sortable: true },
        { key: "carcaca", label: "Carcaça", sortable: true },
        { key: "medida", label: "Medida", sortable: true },
        { key: "vida", label: "Vida", sortable: true },
        {
          key: "dt_cadastro",
          label: "Cadastro",
          sortable: true,
          formatter: (value, key, pneunoregistros) => {
            return moment(pneunoregistros.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    limparFiltro() {
      this.search = "";
    },

    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFilial() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.filiais = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_filial_erp,
              filial: emp.filial,
              empresa_id: emp.empresa_id,
            };
          });
        })
        .catch(showError);
    },
    loadAcao(tab) {
      console.log(tab);
      let corpo = {
        tabselecionada: tab,
      };
      const url = `${baseApiUrl}/pneu/acao`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.acoes = res.data.map((gru) => {
            return { ...gru, value: gru.id, acao: gru.acao, id: gru.id };
          });
        })
        .catch(showError);
    },

    loadVeiculo() {
      let corpo = {
        id_empresa: `${this.user.id_grupo_empresa}`,
        prefixo: `${this.pneu.prefixo}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.veiculos = res.data;
        })
        .catch(showError);
    },

    ///CHASSI MODELO
    loadDanos() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/danos`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.danos = res.data.map((sb) => {
            return { ...sb, value: sb.id, danos: sb.danos };
          });
        })
        .catch(showError);
    },

    loadAvarias() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        danos_id: `${this.value_danos_id}`,
      };
      const url = `${baseApiUrl}/pneu/avarias`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.avarias = res.data.map((sb) => {
            return { ...sb, value: sb.id, avarias: sb.s };
          });
        })
        .catch(showError);
    },

    async postPneusMov() {
      //const valor = this.value_vlr_pneu_conserto.replace(/,/g, '.');

      let corpo = {
        id_funcionario: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        nrofogo_id:
          this.pneuselecao !== null &&
          (this.pneuselecao["id"] > 0) & (this.pneuselecao !== "")
            ? `${this.pneuselecao["id"]}`
            : `${this.pneu.nrofogo_id}`,
        acao_id: `${this.value_acao}`,
        prefixo_id: `${this.veiculos.map((at) => at.id_veiculo).join(", ")}`, //  veiculos ? veiculos.map(at => at.id_veiculo).join(', ')
        posicao_id: `${this.pneu.posicao_id}`,
        vida_id: `${this.pneuselecao["vida_id"]}`,
        km_rodado: `${this.pneu.km_rodado}`,
        sulco: `${this.pneu.sulco}`,
        libras: `${this.pneu.libras}`,
        odometro: `${this.pneu.odometro}`,
        danos_id: `${this.value_danos_id}`,
        avaria_id: `${this.value_avaria_id}`,
        fornecedor_id: `${this.pneu.fornecedor_id}`,
        dt_emissao:
          this.value_dt_emissao !== "" ? `${this.value_dt_emissao}` : null,
        nf: `${this.value_pneu_nfs}`,
        observacao: `${this.value_observacao}`,
        alinhamento: `${this.pneu.alinhamento}`,
        balanceamento: `${this.pneu.balanceamento}`,
        calibragem: `${this.pneu.calibragem}`,
        tampa_metalica: `${this.pneu.tampa_metalica}`,
        ressulcado: `${this.pneu.ressulcado}`,
        fornecedor_id: `${this.value_fornecedor}`, // 23/04/2024
        romaneio: `${this.nroromaneio}`, // 23/04/2024
        valor:
          this.value_vlr_pneu_conserto > 0.0
            ? this.value_vlr_pneu_conserto.replace(/,/g, ".")
            : null, // 23/04/2024
        emissao: this.value_dt_emissao !== "" ? this.value_dt_emissao : null, // 23/04/2024
        recapagem_tipo_id:
          this.value_servico == 2 && this.value_sucata == false
            ? `${this.value_recapagemtipo}`
            : null,
        borracha_id:
          this.value_servico == 2 && this.value_sucata == false
            ? `${this.value_borracha}`
            : null,
        carcaca_id:
          this.value_servico == 2 && this.value_sucata == false
            ? `${this.value_carcaca}`
            : null,
        recapagem_recusada: this.value_sucata,
      };
      const url = `${baseApiUrl}/pneu/pneumov`;
      axios
        .post(url, corpo)
        .then(() => {
          //this.$toasted.global.defaultSuccess()
          if (this.value_acao == 1 || this.value_acao == 2) {
            this.postPneusVeiculo();
            this.loadPneuLancamentos();
          } else if (this.value_acao == 3) {
            this.postPneusVeiculo();
            this.postPneusMovSub();
          } else if (this.value_acao == 8) {
            this.postPneusVeiculo();
            this.postPneusMovSub();
          } else if (
            this.value_acao == 4 ||
            this.value_acao == 5 ||
            this.value_acao == 9
          ) {
            this.updatePneusCadastro();
            this.loadPneuLancamentos();
          } else if (this.value_acao == 9 || this.value_acao == 10) {
            this.postPneusVeiculo();
            this.loadPneuLancamentos();
          } else {
            this.$toasted.global.defaultSuccess();
            this.reset();
            this.loadPneuLancamentos();
          }
        })
        .catch(showError);
    },

    async postPneusMovRodizio(posicao, pneu) {
      let corpo = {
        id_funcionario: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        //"nrofogo_id":  this.pneu.nrofogo_id == null ?  `${this.pneuselecao['id']}` : `${this.pneu.nrofogo_id}`,
        nrofogo_id: pneu,
        acao_id: `${this.value_acao}`,
        prefixo_id: `${this.veiculos.map((at) => at.id_veiculo).join(", ")}`, //  veiculos ? veiculos.map(at => at.id_veiculo).join(', ')
        posicao_id: posicao,
        vida_id: `${this.pneuselecao["vida_id"]}`,
        km_rodado: `${this.pneu.km_rodado}`,
        sulco: `${this.pneu.sulco}`,
        libras: `${this.pneu.libras}`,
        odometro: `${this.pneu.odometro}`,
        danos_id: `${this.value_danos_id}`,
        avaria_id: `${this.value_avaria_id}`,
        fornecedor_id: `${this.pneu.fornecedor_id}`,
        dt_emissao: `${this.pneu.dt_emissao}`,
        nf: `${this.pneu.nf}`,
        valor: `${this.pneu.valor}`,
        observacao: `${this.value_observacao}`,
        alinhamento: `${this.pneu.alinhamento}`,
        balanceamento: `${this.pneu.balanceamento}`,
        calibragem: `${this.pneu.calibragem}`,
        tampa_metalica: `${this.pneu.tampa_metalica}`,
        ressulcado: `${this.pneu.ressulcado}`,
      };
      const url = `${baseApiUrl}/pneu/pneumov`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset();
          this.loadPneuLancamentos();
        })
        .catch(showError);
    },

    async postPneusMovSub() {
      let corpo = {
        id_funcionario: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        //"nrofogo_id":  this.pneu.nrofogo_id == null ?  `${this.pneuselecao['id']}` : `${this.pneu.nrofogo_id}`,
        nrofogo_id: `${this.pneu.nrofogo_id}`,
        acao_id: `${this.value_acao}`,
        prefixo_id: `${this.veiculos.map((at) => at.id_veiculo).join(", ")}`, //  veiculos ? veiculos.map(at => at.id_veiculo).join(', ')
        posicao_id: `${this.pneu.posicao_id}`,
        vida_id: `${this.pneuselecao["vida_id"]}`,
        km_rodado: `${this.pneu.km_rodado}`,
        sulco: `${this.pneu.sulco}`,
        libras: `${this.pneu.libras}`,
        odometro: `${this.pneu.odometro}`,
        danos_id: `${this.value_danos_id}`,
        avaria_id: `${this.value_avaria_id}`,
        fornecedor_id: `${this.pneu.fornecedor_id}`,
        dt_emissao: `${this.pneu.dt_emissao}`,
        nf: `${this.pneu.nf}`,
        valor: `${this.pneu.valor}`,
        observacao: `${this.value_observacao}`,
        alinhamento: `${this.pneu.alinhamento}`,
        balanceamento: `${this.pneu.balanceamento}`,
        calibragem: `${this.pneu.calibragem}`,
        tampa_metalica: `${this.pneu.tampa_metalica}`,
        ressulcado: `${this.pneu.ressulcado}`,
        operacao: "retirado",
      };
      const url = `${baseApiUrl}/pneu/pneumov`;
      axios
        .post(url, corpo)
        .then(() => {
          this.updatePneusCadastroSub();
        })
        .catch(showError);
    },

    async postPneusVeiculo() {
      ////////////////////////////// ATUALIZA O PNEU NA POSIÇÃO DO CHASSI DO VEICULOS
      let corpo = {
        id_funcionario: `${this.user.id_funcionario}`,
        acao_id: `${this.value_acao}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        prefixo_id: `${this.veiculos.map((at) => at.id_veiculo).join(", ")}`, //  veiculos ? veiculos.map(at => at.id_veiculo).join(', ')      --  chassimodelo_id
        chassimodelo_id: `${this.veiculos
          .map((at) => at.chassimodelo_id)
          .join(", ")}`,
        posicao_id: `${this.pneu.posicao_id}`,
        nrofogo_id: `${this.pneuselecao["id"]}`,
      };
      const url = `${baseApiUrl}/pneu/pneuveiculomov`;
      axios
        .post(url, corpo)
        .then(() => {
          this.updatePneusCadastro();
        })
        .catch(showError);
    },

    async uptPneusVeiculoRodizio(posicao, fogo_id) {
      ////////////////////////////// ATUALIZA O PNEU NA POSIÇÃO DO CHASSI DO VEICULOS
      let corpo = {
        id_funcionario: `${this.user.id_funcionario}`,
        acao_id: `${this.value_acao}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        prefixo_id: `${this.veiculos.map((at) => at.id_veiculo).join(", ")}`, //  veiculos ? veiculos.map(at => at.id_veiculo).join(', ')      --  chassimodelo_id
        chassimodelo_id: `${this.veiculos
          .map((at) => at.chassimodelo_id)
          .join(", ")}`,
        posicao_id: posicao,
        nrofogo_id: fogo_id,
        //"posicao_id": `${this.pneu.posicao_id}`,
        //"nrofogo_id": `${this.pneuselecao['id']}`
      };
      const url = `${baseApiUrl}/pneu/pneuveiculomov`;
      axios
        .post(url, corpo)
        .then(() => {
          this.loadPneuVeiculo();
        })
        .catch(showError);
    },

    async updatePneusCadastro() {
      ////////////////////////// ATUALIZA O STATUS DO PNEU NO CADASTRO DE PNEUS
      let corpo = {
        acao_id: `${this.value_acao}`,
        id_funcionario: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        nrofogo_id:
          this.pneuselecao !== null &&
          (this.pneuselecao["id"] > 0) & (this.pneuselecao !== "")
            ? `${this.pneuselecao["id"]}`
            : `${this.pneu.nrofogo_id}`,
        vida_id:
          this.value_servico == 2 && this.value_sucata == false
            ? `${this.pneuselecao["vida_id"] + 1}`
            : null,
        borracha_id:
          this.value_servico == 2 && this.value_sucata == false
            ? `${this.value_borracha}`
            : null,
        carcaca_id:
          this.value_servico == 2 && this.value_sucata == false
            ? `${this.value_carcaca}`
            : null,
        recapagem_recusada: this.value_sucata,
      };
      const url = `${baseApiUrl}/pneu/pneustatusmov`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadPneuVeiculo();
          this.reset();
        })
        .catch(showError);
    },

    async updatePneusCadastroSub() {
      let corpo = {
        acao_id: `${this.value_acao}`,
        id_funcionario: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.value_filial}`,
        nrofogo_id: `${this.pneu.nrofogo_id}`,
        status_id: 1,
        colocado: "retirado",
      };
      const url = `${baseApiUrl}/pneu/pneustatusmov`;
      axios
        .post(url, corpo)
        .then(() => {
          this.loadPneuVeiculo();
          this.loadPneuLancamentos();
        })
        .catch(showError);
    },

    ///////////////////////////////// 31/12/2022 as 20:17h
    editPneu(pneu) {
      this.pneu = { ...pneu };
    },

    loadPneu() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        nrofogo: `${this.value_pneu_colocado}`,
        origem: "lancamento",
      };
      const url = `${baseApiUrl}/pneu/pneu`;

      axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.pneuselecao = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            pneuselecao = {};
          }
        })
        .catch(showError);
    },

    async loadPneuVeiculo() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        prefixo: `${this.pneu.prefixo}`,
      };
      const url = `${baseApiUrl}/pneu/pneuveiculo`;

      // Retornando a promessa para que a chamada que invoca loadPneuVeiculo() possa esperar
      await axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.pneunoveiculo = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            this.pneunoveiculo = {};
          }
          // Retorna os dados para que o chamador possa usá-los, se necessário
          return res.data;
        })
        .catch(showError);
    },

    async loadPneuLancamentos() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/pneregistros`;

      // Retornando a promessa para que a chamada que invoca loadPneuVeiculo() possa esperar
      await axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.pneunoregistros = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            this.pneunoregistros = {};
          }
          // Retorna os dados para que o chamador possa usá-los, se necessário
          return res.data;
        })
        .catch(showError);
    },

    //////////////////////// rodizio
    loadPneuAlocadoA() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        prefixo: `${this.pneu.prefixo}`,
      };
      const url = `${baseApiUrl}/pneu/pnealocadoveiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.rodozioA = res.data.map((gru) => {
            return {
              ...gru,
              value: gru.posicao_id,
              nrofogo_id: gru.nrofogo_id,
              posicao: gru.posicao,
            };
          });
        })
        .catch(showError);
    },

    loadPneuAlocadoB() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        prefixo: `${this.pneu.prefixo}`,
      };
      const url = `${baseApiUrl}/pneu/pnealocadoveiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.rodozioB = res.data.map((gru) => {
            return {
              ...gru,
              value: gru.posicao_id,
              nrofogo_id: gru.nrofogo_id,
              posicao: gru.posicao,
            };
          });
        })
        .catch(showError);
    },

    loadPneuFornecedores() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        origem: "listagem",
      };
      const url = `${baseApiUrl}/fin/clifor`;
      axios
        .get(url, { params })
        .then((res) => {
          this.fornecedores = res.data.map((gru) => {
            return { ...gru, value: gru.id, nome: gru.nome };
          });
        })
        .catch(showError);
    },

    reset() {
      this.pneu.posicao = "";
      this.value_observacao = "";
    },

    loadNovoNroRomaneio() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/nroromaneio`;
      axios.get(url, { params }).then((res) => {
        this.nroromaneio = res.data.rows[0].nextval;
      });
    },

    loadPneuRecapadoraServico() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/recapadoraservico`;
      axios
        .get(url, { params })
        .then((res) => {
          this.recapadoraservico = res.data.map((gru) => {
            return { ...gru, value: gru.id, servico: gru.servico };
          });
        })
        .catch(showError);
    },

    loadPneuRecapagemTipo() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/recapagemtipo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.recapagemtipo = res.data.map((gru) => {
            return { ...gru, value: gru.id, tipo: gru.tipo };
          });
        })
        .catch(showError);
    },

    loadBorracha() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/borracha`;
      axios
        .post(url, { params })
        .then((res) => {
          this.borrachas = res.data.map((gru) => {
            return { ...gru, value: gru.id, borracha: gru.borracha };
          });
        })
        .catch(showError);
    },

    loadCarcaca() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/desenho`;
      axios
        .get(url, { params })
        .then((res) => {
          this.carcacas = res.data.map((gru) => {
            return { ...gru, value: gru.id, desenho: gru.desenho };
          });
        })
        .catch(showError);
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadFilial();
    this.loadPneuLancamentos();
    this.loadPneuFornecedores();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#placa {
  font-size: 0.7em;
}

#modal-multi-pneu___BV_modal_content_ {
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;
}

#defeito-selecao {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-sos {
  background: rgb(199, 222, 218);
  border: 1px solid red;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-encerramento {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#pneu-nro {
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
}

#garagem {
  font-size: 12px;
  text-align: center;
}

.blue-border {
  border: 1px solid blue;
}

.rounded {
  border-radius: 18px; /* ou qualquer valor que desejar */
}
</style>

